module.exports = __webpack_public_path__ + "static/etkilesim-b7ed17310121e9a9f985ff945f53b10c.webp";